<template>
  <v-app>
    <v-app-bar app color="green" dark>
      <v-menu bottom :offset-y="offset">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="ma-2" light v-bind="attrs" v-on="on"
            ><v-icon dark> mdi-format-list-bulleted-square </v-icon></v-btn
          >
        </template>

        <v-list>
          <v-list-item v-for="(item, i) in items" :key="i" :to="item.to">
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-spacer></v-spacer>

      <div class="d-flex align-center">
        <v-img
          alt="Greennote logo"
          class="shrink mr-2"
          contain
          src="./assets/greennote-white.png"
          transition="scale-transition"
          width="300"
        />
      </div>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
    selectedItem: 1,
    items: [
      {
        title: "トップページ",
        to: "/",
      },
      {
        title: "ログイン",
        to: "/signin",
      },
      {
        title: "システムについて",
        to: "/about",
      },
    ],
    offset: true,
  }),

  methods: {
    handleClick(index) {
      this.items[index].click.call(this);
    },
  },

  mounted() {
    const title = "グリーンノート　オンライン研修システム";
    document.title = title;
  },
};
</script>
